import { useLazyQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../../common/constants';
import CommonCard from '../../../components/CommonCard';
import CommonTable from '../../../components/CommonTable';
import Portal from '../../../components/Portal';
import SearchComponent from '../../../components/SearchComponent';
import { GET_USERS } from '../graphql/Queries';

const UserTable = () => {
  const initialUserFilter = {
    skip: 0,
    limit: 10,
    search: '',
    sortBy: { field: 'id', order: 'ASC' },
  };
  const initialPaginationValue = {
    total: 0,
    current: 1,
  };
  const [paginationProp, setPaginationProp] = useState(initialPaginationValue);
  const [userFilter, setUserFilter] = useState(initialUserFilter);
  const [sortedInfo, setSortedInfo] = useState({});
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

  const [fetchUserData, { loading, data }] = useLazyQuery(GET_USERS, {
    fetchPolicy: 'network-only',
    onError() {},
  });

  useEffect(() => {
    fetchUserData({
      variables: {
        filter: { ...userFilter },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getData = async (value) => {
    setUserFilter({ ...userFilter, search: value });
    fetchUserData({
      variables: {
        filter: {
          ...userFilter,
          search: value,
        },
      },
    });
  };

  const handleTableChange = (pagination, paginationFilter, sorter) => {
    const { current } = pagination;
    const skip = (current - 1) * pagination?.pageSize;
    setPaginationProp({ ...paginationProp, ...pagination });
    setUserFilter({ ...userFilter, limit: pagination?.pageSize });
    setSortedInfo(sorter);
    if (sorter?.column) {
      fetchUserData({
        variables: {
          filter: {
            ...userFilter,
            skip,
            limit: pagination?.pageSize,
            sortBy: {
              field: sorter?.columnKey,
              order: sorter?.order === 'ascend' ? 'ASC' : 'DESC',
            },
          },
        },
      });
    } else {
      fetchUserData({
        variables: {
          filter: {
            ...userFilter,
            sortBy: {
              field: 'id',
              order: 'ASC',
            },
          },
        },
      });
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: '',
      key: 'id',
      render: (text, record, index) => {
        return <>{index + 1}</>;
      },
      width: '15%',
    },

    {
      title: 'USERNAME',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'name' && sortedInfo?.order,
      width: '30%',
    },
    {
      title: 'EMAIL',
      dataIndex: 'email',
      key: 'email',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'email' && sortedInfo?.order,
      width: '60%',
    },
  ];
  return (
    <>
      <Portal portalId="header-right-content">
        <div className="users-search">
          <SearchComponent
            id="search-container-id"
            name="Users"
            getData={getData}
          />
        </div>
      </Portal>
      {isDesktopViewport ? (
        <CommonTable
          loadingData={loading}
          columns={columns}
          data={data?.superAdminList?.data || []}
          onChange={handleTableChange}
          rowKey={(obj) => obj.id}
          paginationConfig={paginationProp}
        />
      ) : (
        <div className="users-card pointer">
          {data?.superAdminList?.data?.map((userData) => {
            return (
              <div key={userData?.id}>
                <CommonCard>
                  <div>
                    <div className="card-header">
                      <h1>{userData?.name}</h1>
                    </div>
                    <div className="card-content">
                      <p>{userData?.email}</p>
                    </div>
                  </div>
                </CommonCard>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default UserTable;
